import type * as Types from 'app/types/graphql';

import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { appFetcher } from '~/api/utils/gatewayClient';
export type ShopExtensionQueryVariables = Types.Exact<{
  extensionID: Types.Scalars['String']['input'];
}>;

export type ShopExtensionQueryResponse = {
  shopExtension?: Types.Maybe<Pick<Types.ShopExtension, 'themeAppExtensionEnabled'>>;
};

export const ShopExtensionDocument = `
    query ShopExtension($extensionID: String!) {
  shopExtension(extensionID: $extensionID) {
    themeAppExtensionEnabled
  }
}
    `;

export const useShopExtensionQuery = <TData = ShopExtensionQueryResponse, TError = unknown>(
  variables: ShopExtensionQueryVariables,
  options?: UseQueryOptions<ShopExtensionQueryResponse, TError, TData>,
) => {
  return useQuery<ShopExtensionQueryResponse, TError, TData>(
    ['ShopExtension', variables],
    appFetcher<ShopExtensionQueryResponse, ShopExtensionQueryVariables>(
      ShopExtensionDocument,
      variables,
    ),
    options,
  );
};

useShopExtensionQuery.getKey = (variables: ShopExtensionQueryVariables) => [
  'ShopExtension',
  variables,
];
